angular.module('app').directive('variaveisTemplate', function() {
	return {
        restrict: 'E',
        templateUrl: 'assets/admin/html/variaveis-template.html?v='+angular.element('meta[name="version-id"]').attr('content'), 
        scope:{
            ngModel: '='
        },
        controller: function($scope, $timeout) {
            $scope.exibirAjuda = false;

            $scope.copiar = function(str, $event){
                str = '%'+str+'%';
                navigator.clipboard.writeText(str).then(function() {
                    $($event.currentTarget).attr('title','Copiado!').tooltip('show');
                    $timeout(function(){
                        $($event.currentTarget).attr('title','Copiar')
                            .tooltip('destroy'); 
                    }, 2000);
                }, function(err) {
                    console.error('Async: Could not copy text: ', err);
                    alert('Seu navegador não possui suporte para cópia virtual de texto. Digite a variável manualmente ou utilize um navegador compatível.');
                });
            };

            $scope.ajuda = function(){
                $scope.exibirAjuda = !$scope.exibirAjuda;
            };
        }
    };
})